/*
 * multipleIDs
 *
 * Check for multiple IDs and throw warning. Relevant because we use IDs for displaying the correct fields per page.
 *
 * Source: https://stackoverflow.com/questions/482763/jquery-to-check-for-duplicate-ids-in-a-dom
 */

const multipleIDs = () => {
  $('[id]').each(function iterator() {
    const ids = $(`[id="${this.id}"]`);
    if (ids.length > 1 && ids[0] === this) {
      console.warn(`Multiple IDs #${this.id}`); // eslint-disable-line no-console
    }
  });
};

export default multipleIDs;
